import * as React from "react";
import { useEffect, useState } from "react";



import { customerService } from "../../services/customer.service";
import {
  SetCustomerRewardAtom,
  GetCustomerRewardAtom,
} from "../../store/customerRewardpoint";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";




const columns = [
  {
    title: 'Ref_No',
    key: 'Ref_No',
    dataIndex: 'Ref_No',
  className: "text-primary",
  sorter: (a, b) => (a?.Ref_No ?? '') - (b?.Ref_No ?? '')

  },

   
  {
    title: "Date",
    dataIndex: "Transaction_Date_String",
    sorter: (a, b) => (a?.Transaction_Date_String ?? '').localeCompare(b?.Transaction_Date_String ?? '')

  },

  {
    title: " Title",
    dataIndex: "Reward_Earn_Title",
    sorter: (a, b) => (a?.Reward_Earn_Title ?? '').localeCompare(b?.Reward_Earn_Title ?? '')
  },

  {
    title: "Reward Cowries",
    dataIndex: "Reward_Cowries_Quantity",
  sorter: (a, b) => (a?.Reward_Cowries_Quantity ?? '') - (b?.Reward_Cowries_Quantity ?? ''),
     render: (record) => <span> {record} </span>,

  },
  {
    title: "Remark",
    dataIndex: "Reward_Remark",
    sorter: (a, b) => (a?.Reward_Remark ?? '').localeCompare(b?.Reward_Remark ?? '')

  },
 
];



export default function RewardPointTab({ customer_id }) {
  const [tableList, setTableList] = useState([]);
  const setRewardList = SetCustomerRewardAtom();
  const rewardAtomList = GetCustomerRewardAtom();


  useEffect(() => {
   
      getDataFromServer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer_id]);

  const getDataFromServer = () => {
    let isMounted = true;
    customerService.getRewardHistory(customer_id).then((res) => {
      if (isMounted && res.data?.length) {
        let tempList = res.data.map((item) => {
          return { ...item, id: item?.Ref_No };
        });
        setRewardList(tempList);
        setTableList(tempList);

      }else if (isMounted) {
        setRewardList([]);
        setTableList([]);
      }
    });
    return () => {
      isMounted = false;
    };
  };


  return (
    <>
      <div className="ml-1 @container">
        <div className="mt-1 text-gray-600 text-xl font-bold">Reward Point</div>

      
        <section className="mt-5">
              <GeneralCustomTable
                                tableHeadList={columns} 
                                tableDataList={tableList}
                                allowCheckBox={false} // show checkBox for each row
                                // setSelectedRows={selectCustomer}
                                rowKey={(record) => record.Ref_No} // custom key
                                handleRowClick={()=> console.log('click')}
                                 />
                             </section>
      </div>
      
    </>
  );
}
